<script setup lang="ts">
import { analytics } from '@/scitylana';

import TruButton from '../TruButton.vue';
import TruCard from '../TruCard.vue';

function openLinkedIn() {
    analytics.home.linkedIn();

    window.open('https://www.linkedin.com/showcase/trupanion-vet-pros/');
}
</script>

<template>
    <div class="trupanion-on-linkedin">
        <TruCard :header="$t('dashboard.trupanionOnLinkedIn.header')">
            <img
                src="../../assets/images/linkedin_graphic.png"
                :alt="$t('dashboard.trupanionOnLinkedIn.altText')"
                class="cursor-pointer"
                @click="openLinkedIn"
            >

            <p>{{ $t('dashboard.trupanionOnLinkedIn.linkedInText') }}</p>

            <div class="flex flex-col items-center">
                <TruButton
                    secondary
                    size="xs"
                    @click="openLinkedIn"
                >
                    {{ $t('dashboard.trupanionOnLinkedIn.visit') }}
                </TruButton>
            </div>
        </TruCard>
    </div>
</template>

<style scoped lang="scss">

</style>
